import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { defaultInputDateFormat } from 'assets/utils/data/Date';
import ContractCancellationReasons from 'models/enums/ContractCancellationReasons';
import { ContractRefundCancellationForm } from '../Contract.RefundCancellation';

const ContractRefundCancellationDetails = () => {
  const { form } = useModalForm<ContractRefundCancellationForm>();
  const { lang } = getLocales();
  return (
    <FormWrapper>
      <DateInput
        name="cancellationDateLocal"
        label={lang.cancellationDate}
        dateTimeFormat={defaultInputDateFormat}
        isLocal={true}
        value={form?.data?.cancellationDateLocal}
        error={form?.errors?.cancellationDateLocal}
        onChange={form.update}
        icon={<Icon class="fas-calendar-alt" />}
      />
      <SelectInput
        name="reason"
        label={lang.cancellationReason}
        value={form?.data?.reason}
        error={form?.errors?.reason}
        data={Object.values(ContractCancellationReasons).map((id) => ({
          id,
          title: id,
        }))}
        onChange={form.update}
      />
      {form.data?.reason === ContractCancellationReasons.OTHER && (
        <MultilineTextInput
          name="reasonDescription"
          label={lang.cancellationReasonDescription}
          value={form?.data?.reasonDescription}
          error={form?.errors?.reasonDescription}
          onChange={form.update}
        />
      )}
      <NumberInput
        name="odometerReading"
        label={lang.odometerReading}
        value={form?.data?.odometerReading}
        error={form?.errors?.odometerReading}
        onChange={form.update}
      />
      <hr />
    </FormWrapper>
  );
};

export default ContractRefundCancellationDetails;
